import React from 'react'
import Snackbar from '@mui/material/Snackbar'
import { Box, Grow, Stack, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close'
import { removeAlert } from '../../../Redux/Reducers/AppSlice'

const FloatingAlerts = () => {
//   const alerts = useSelector((state) => state.app.alerts)
const alerts = useSelector((state) => state.app.alerts)
  const dispatch = useDispatch()

  const handleClose = () => {
    dispatch(removeAlert())
  }
  return (
    <Stack
      spacing={2}
      sx={{
        width: '100%',
        zIndex: 99,
        '& .MuiSnackbar-root': {
          '& .MuiPaper-root': {
            p: 1,
            borderRadius: '8px',
          },
        },
        '& .MuiSnackbarContent-message': {
          width: '100%',
          p: 0,
        },
        '& .MuiSnackbarContent-root': {
          background: '#cecbcb',
          border: '#FFFFFF33'
        },
      }}
    >
      {alerts.map((alert) => (
        <Snackbar
          key={alert.key}
          open
          onClose={handleClose}
          TransitionComponent={(props) => <Grow {...props} />}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          message={
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              color="text.primary"
              width="100%"
            >
              <Box
                display="flex"
                alignItems="center"
                sx={{
                  '& svg': {
                    color: (theme) =>
                      alert.severity === 'success'
                        ? theme.palette.primary.main
                        : theme.palette.error.main,
                    fontSize: 24,
                    mr: 1,
                  },
                }}
              >
                {alert.severity === 'success' ? (
                  <CheckCircleIcon />
                ) : (
                  <CancelIcon />
                )}
                <Typography variant="p" p={0}>
                  {alert.message}
                </Typography>
              </Box>
              <CloseIcon
                sx={{ cursor: 'pointer' }}
                fontSize="small"
                onClick={handleClose}
              />
            </Box>
          }
        />
      ))}
    </Stack>
  )
}

export default FloatingAlerts
